import { useEffect, useRef, useContext } from 'react';
import {
    isPhoneSize,
    getTomorrow,
    thirtyDaysFromNow,
    shadeColor,
} from 'utils/util';
import { USDollar, toTitleCase } from 'utils/format';
import { useNavigate } from 'react-router-dom';
import { GlobalContext } from 'GlobalContext';
import { formatCurrency } from 'utils/format';

function Header(props) {
    const { topScrollRef, panelBackgroundColor } = props;
    const { payoutTableColumnsToShow, payoutsColumns, payoutTableWidth } =
        useContext(GlobalContext);
    function HeaderItem(props) {
        const { columnName } = props;
        return (
            <>
                {payoutTableColumnsToShow[columnName] && (
                    <div
                        style={{
                            width: `${payoutsColumns[columnName]}px`,
                            textAlign: 'center',
                            alignContent: 'center',
                        }}
                    >
                        {columnName}
                    </div>
                )}
            </>
        );
    }
    return (
        <div
            ref={topScrollRef}
            style={{
                overflowX: 'auto',
                scrollbarWidth: 'none',
                background: panelBackgroundColor,
                borderRadius: '8px 8px 0 0',
            }}
        >
            <div
                style={{
                    width: `${payoutTableWidth + 40}px`,
                    display: 'flex',
                    flexDirection: 'row',
                    // borderBottom: '1px solid black',
                }}
            >
                <div
                    style={{
                        width: `${payoutsColumns['Investment Entity']}px`,
                        textAlign: 'center',
                        alignContent: 'center',
                    }}
                >
                    {'Investment Entity'}
                </div>
                <HeaderItem columnName={'Investor'} />
                <HeaderItem columnName={'Fund'} />
                <HeaderItem columnName={'Payment Company'} />
                <HeaderItem columnName={'Start Date'} />
                <HeaderItem columnName={'End Date'} />
                <HeaderItem columnName={'Currency'} />
                <HeaderItem columnName={'Frequency'} />
                <HeaderItem columnName={'Interest'} />
                <HeaderItem columnName={'Invested Amount'} />
                <HeaderItem columnName={'Account Balance'} />
                <HeaderItem columnName={'Amount'} />
                <HeaderItem columnName={'Type'} />
                <HeaderItem columnName={'Next Payment Date'} />
                <HeaderItem columnName={'Next Payment Due'} />
                <HeaderItem columnName={'Status'} />
                <HeaderItem columnName={'Pay'} />
            </div>
        </div>
    );
}

function Summary(props) {
    const { totalInterestAmount, SummaryScrollRef, panelBackgroundColor } =
        props;
    const { payoutTableColumnsToShow, payoutsColumns, payoutTableWidth } =
        useContext(GlobalContext);

    function SummaryItem(props) {
        const { columnName } = props;
        return (
            <>
                {payoutTableColumnsToShow[columnName] && (
                    <div
                        style={{
                            width: `${payoutsColumns[columnName]}px`,
                            textAlign: 'center',
                            alignContent: 'center',
                        }}
                    ></div>
                )}
            </>
        );
    }

    return (
        <div
            ref={SummaryScrollRef}
            style={{
                overflowX: 'auto',
                scrollbarWidth: 'none',
                background: panelBackgroundColor,
            }}
        >
            <div
                style={{
                    width: `${payoutTableWidth + 40}px`,
                    display: 'flex',
                    flexDirection: 'row',
                    // border: '1px solid black',
                    borderLeft: '0px',
                }}
            >
                <div
                    style={{
                        width: '150px',
                        textAlign: 'center',
                        alignContent: 'center',
                    }}
                >
                    Sum
                </div>
                <SummaryItem columnName={'Investor'} />
                <SummaryItem columnName={'Fund'} />
                <SummaryItem columnName={'Payment Company'} />
                <SummaryItem columnName={'Start Date'} />
                <SummaryItem columnName={'End Date'} />
                <SummaryItem columnName={'Currency'} />
                <SummaryItem columnName={'Frequency'} />
                <SummaryItem columnName={'Interest'} />
                <SummaryItem columnName={'Invested Amount'} />
                <SummaryItem columnName={'Account Balance'} />
                {payoutTableColumnsToShow['Amount'] && (
                    <div
                        style={{
                            width: '100px',
                            textAlign: 'center',
                            alignContent: 'center',
                        }}
                    >
                        {USDollar.format(totalInterestAmount)}
                    </div>
                )}
                <SummaryItem columnName={'Type'} />
                <SummaryItem columnName={'Next Payment Date'} />
                <SummaryItem columnName={'Next Payment Due'} />
                <SummaryItem columnName={'Status'} />
                <SummaryItem columnName={'Pay'} />
            </div>
        </div>
    );
}

function ByAccount(props) {
    const navigate = useNavigate();
    const {
        setManageRecordTab,
        setManageRecordId,
        payoutTableColumnsToShow,
        payoutsColumns,
    } = useContext(GlobalContext);
    const {
        payoutsRaw,
        payouts,
        accountId2accountName,
        setAccountIdToView,
        accountId2Investors,
        transactionId2Status,
        timezoneOffset,
        handleStatusChange,
        totalInterestAmount,
        accountId,
        idx,
        SummaryScrollRef,
        accountId2Currency,
        investorBgBase,
    } = props;

    function MainItem(props) {
        const { columnName, columnText, background } = props;
        return (
            <>
                {payoutTableColumnsToShow[columnName] && (
                    <div
                        style={{
                            width: `${payoutsColumns[columnName]}px`,
                            textAlign: 'center',
                            alignContent: 'center',
                            background,
                        }}
                    >
                        {columnText}
                    </div>
                )}
            </>
        );
    }

    return (
        <div
            ref={SummaryScrollRef}
            key={idx}
            style={{
                display: 'flex',
                flexDirection: 'row',
                // borderTop: idx === 0 ? '' : '1px solid black',
                height: '100%',
            }}
        >
            <div
                style={{
                    width: '150px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    background: investorBgBase,
                }}
            >
                <div
                    style={{
                        color: 'blue',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        height: 'fit-content',
                    }}
                    onClick={() => {
                        navigate('/recordManager');
                        setManageRecordTab('Investment Entities');
                        setManageRecordId(accountId);
                        // setAccountIdToView(accountId);
                    }}
                >
                    {accountId2accountName[accountId]}
                </div>
                {/* <div>
                    {accountId2Currency[accountId] === 'USD'
                        ? '$ USD'
                        : '￥CNY'}
                </div> */}
            </div>

            {payoutTableColumnsToShow['Investor'] && (
                <div
                    style={{
                        width: '150px',
                        textAlign: 'center',
                        background: investorBgBase,
                    }}
                >
                    {accountId2Investors[accountId].map((investor, id) => (
                        <div key={id}>
                            <div
                                style={{
                                    color: 'blue',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                    height: 'fit-content',
                                }}
                                onClick={() => {
                                    navigate('/recordManager');
                                    setManageRecordTab('Investors');
                                    setManageRecordId(investor.investor_id);
                                    // setAccountIdToView(accountId);
                                }}
                            >
                                {investor.legal_name}
                            </div>
                            <div style={{}}>{investor.email}</div>
                        </div>
                    ))}
                </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column' }}>
                {payouts[accountId]
                    .sort((a, b) => {
                        if (a.fund_name === b.fund_name) {
                            if (a.timestamp > b.timestamp) {
                                return -1;
                            }
                            return 1;
                        }
                        if (a.fund_name < b.fund_name) {
                            return -1;
                        }
                        return 1;
                    })
                    .map((transaction, idx) => {
                        // per transaction
                        return (
                            <div
                                key={idx}
                                style={{
                                    // borderTop:
                                    //     idx === 0 ? '' : '1px solid black',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    height: '100%',
                                }}
                            >
                                <MainItem
                                    background={
                                        idx % 2 === 0
                                            ? investorBgBase
                                            : shadeColor(investorBgBase, -5)
                                    }
                                    columnName={'Fund'}
                                    columnText={transaction.fund_name}
                                />
                                <MainItem
                                    background={
                                        idx % 2 === 0
                                            ? investorBgBase
                                            : shadeColor(investorBgBase, -5)
                                    }
                                    columnName={'Payment Company'}
                                    columnText={
                                        transaction.payment_company_name
                                    }
                                />
                                <MainItem
                                    background={
                                        idx % 2 === 0
                                            ? investorBgBase
                                            : shadeColor(investorBgBase, -5)
                                    }
                                    columnName={'Start Date'}
                                    columnText={transaction.funding_receipt_date.slice(
                                        0,
                                        10
                                    )}
                                />

                                <MainItem
                                    background={
                                        idx % 2 === 0
                                            ? investorBgBase
                                            : shadeColor(investorBgBase, -5)
                                    }
                                    columnName={'End Date'}
                                    columnText={transaction.actual_redemption_date.slice(
                                        0,
                                        10
                                    )}
                                />

                                <MainItem
                                    background={
                                        idx % 2 === 0
                                            ? investorBgBase
                                            : shadeColor(investorBgBase, -5)
                                    }
                                    columnName={'Currency'}
                                    columnText={transaction.currency}
                                />

                                <MainItem
                                    background={
                                        idx % 2 === 0
                                            ? investorBgBase
                                            : shadeColor(investorBgBase, -5)
                                    }
                                    columnName={'Frequency'}
                                    columnText={toTitleCase(
                                        transaction.payout_frequency
                                            .replace(' payout', '')
                                            .replace(' Payout', '')
                                    )}
                                />

                                <MainItem
                                    background={
                                        idx % 2 === 0
                                            ? investorBgBase
                                            : shadeColor(investorBgBase, -5)
                                    }
                                    columnName={'Interest'}
                                    columnText={`${
                                        transaction.overall_interest
                                            ? Math.max(
                                                  transaction.overall_interest,
                                                  transaction.annual_interest_rate
                                              )
                                            : transaction.annual_interest_rate
                                    }%`}
                                />

                                <MainItem
                                    background={
                                        idx % 2 === 0
                                            ? investorBgBase
                                            : shadeColor(investorBgBase, -5)
                                    }
                                    columnName={'Invested Amount'}
                                    columnText={formatCurrency(
                                        transaction.invested_amount,
                                        transaction.currency
                                    )}
                                />

                                <MainItem
                                    background={
                                        idx % 2 === 0
                                            ? investorBgBase
                                            : shadeColor(investorBgBase, -5)
                                    }
                                    columnName={'Account Balance'}
                                    columnText={formatCurrency(
                                        transaction.account_balance,
                                        transaction.currency
                                    )}
                                />

                                <MainItem
                                    background={
                                        idx % 2 === 0
                                            ? investorBgBase
                                            : shadeColor(investorBgBase, -5)
                                    }
                                    columnName={'Amount'}
                                    columnText={formatCurrency(
                                        transaction.transaction_amount,
                                        transaction.currency
                                    )}
                                />

                                <MainItem
                                    background={
                                        idx % 2 === 0
                                            ? investorBgBase
                                            : shadeColor(investorBgBase, -5)
                                    }
                                    columnName={'Type'}
                                    columnText={toTitleCase(
                                        transaction.transaction_type
                                    )}
                                />

                                <MainItem
                                    background={
                                        idx % 2 === 0
                                            ? investorBgBase
                                            : shadeColor(investorBgBase, -5)
                                    }
                                    columnName={'Next Payment Date'}
                                    columnText={transaction.timestamp}
                                />

                                <MainItem
                                    background={
                                        idx % 2 === 0
                                            ? investorBgBase
                                            : shadeColor(investorBgBase, -5)
                                    }
                                    columnName={'Next Payment Due'}
                                    columnText={getTomorrow(
                                        transaction.timestamp
                                    )}
                                />

                                <MainItem
                                    background={
                                        idx % 2 === 0
                                            ? investorBgBase
                                            : shadeColor(investorBgBase, -5)
                                    }
                                    columnName={'Status'}
                                    columnText={toTitleCase(
                                        transactionId2Status[
                                            transaction.transaction_id
                                        ]
                                    )}
                                />

                                {payoutTableColumnsToShow['Pay'] && (
                                    <div
                                        style={{
                                            width: '80px',
                                            textAlign: 'center',
                                            alignContent: 'center',
                                            background:
                                                idx % 2 === 0
                                                    ? investorBgBase
                                                    : shadeColor(
                                                          investorBgBase,
                                                          -5
                                                      ),
                                        }}
                                    >
                                        {transactionId2Status[
                                            transaction.transaction_id
                                        ].toLowerCase() !== 'reinvest' &&
                                            new Date(
                                                transaction.timestamp +
                                                    timezoneOffset
                                            ) <= thirtyDaysFromNow() && (
                                                <button
                                                    style={{
                                                        background:
                                                            transactionId2Status[
                                                                transaction
                                                                    .transaction_id
                                                            ].toLowerCase() ===
                                                            'unpaid'
                                                                ? '#10b981'
                                                                : '#ef4444', //"rgb(17 32 86)",
                                                        color: 'white',
                                                        borderRadius: '5px',
                                                    }}
                                                    onClick={() =>
                                                        handleStatusChange(
                                                            transaction,
                                                            accountId2Investors[
                                                                accountId
                                                            ].map(
                                                                (investor) =>
                                                                    investor.email
                                                            ),
                                                            accountId2accountName[
                                                                accountId
                                                            ],
                                                            transaction.transaction_type
                                                        )
                                                    }
                                                >
                                                    {transactionId2Status[
                                                        transaction
                                                            .transaction_id
                                                    ].toLowerCase() === 'unpaid'
                                                        ? 'Pay'
                                                        : 'Unpay'}
                                                </button>
                                            )}
                                    </div>
                                )}
                            </div>
                        );
                    })}
            </div>
        </div>
    );
}

export function Default(props) {
    const defaultScrollRef = useRef(null);
    const topScrollRef = useRef(null); // the "asdasdsadasdsa" scrollable
    const SummaryScrollRef = useRef(null);
    const {
        payoutsRaw,
        payouts,
        accountId2accountName,
        setAccountIdToView,
        accountId2Investors,
        transactionId2Status,
        timezoneOffset,
        handleStatusChange,
        totalInterestAmount,
        loading,
        tableView,
        accountId2Currency,
        backgroundColors,
        panelBackgroundColor,
    } = props;

    const { payoutTableWidth } = useContext(GlobalContext);

    useEffect(() => {
        const defaultEl = defaultScrollRef.current;
        const topEl = topScrollRef.current;

        if (!defaultEl || !topEl) return;

        const handleDefaultScroll = () => {
            topEl.scrollLeft = defaultEl.scrollLeft;
        };
        const handleTopScroll = () => {
            defaultEl.scrollLeft = topEl.scrollLeft;
        };

        defaultEl.addEventListener('scroll', handleDefaultScroll);
        topEl.addEventListener('scroll', handleTopScroll);

        return () => {
            defaultEl.removeEventListener('scroll', handleDefaultScroll);
            topEl.removeEventListener('scroll', handleTopScroll);
        };
    }, [loading, tableView]);

    useEffect(() => {
        const defaultEl = defaultScrollRef.current;
        const bottomEl = SummaryScrollRef.current;

        if (!defaultEl || !bottomEl) return;

        const syncScroll = (source, target) => {
            return () => {
                target.scrollLeft = source.scrollLeft;
            };
        };

        // Add listeners to sync both ways if needed
        defaultEl.addEventListener('scroll', syncScroll(defaultEl, bottomEl));
        bottomEl.addEventListener('scroll', syncScroll(bottomEl, defaultEl));

        return () => {
            defaultEl.removeEventListener(
                'scroll',
                syncScroll(defaultEl, bottomEl)
            );
            bottomEl.removeEventListener(
                'scroll',
                syncScroll(bottomEl, defaultEl)
            );
        };
    }, [loading, tableView]);

    return (
        <>
            {payoutsRaw.length > 0 && (
                <div>
                    <Header
                        topScrollRef={topScrollRef}
                        panelBackgroundColor={panelBackgroundColor}
                    />
                    <div
                        ref={defaultScrollRef}
                        style={{
                            overflowY: 'auto',
                            maxHeight: isPhoneSize()
                                ? 'calc(100vh - 300px)'
                                : 'calc(100vh - 150px)',
                        }}
                    >
                        <div
                            style={{
                                width: `${payoutTableWidth}px`,
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            {Object.keys(payouts)
                                .sort((a, b) => {
                                    if (
                                        accountId2accountName[a] <
                                        accountId2accountName[b]
                                    ) {
                                        return -1;
                                    }
                                    return 1;
                                })
                                .map((accountId, idx) => {
                                    // per account
                                    return (
                                        <ByAccount
                                            key={idx}
                                            accountId={accountId}
                                            idx={idx}
                                            investorBgBase={
                                                backgroundColors[idx % 2]
                                            }
                                            payoutsRaw={payoutsRaw}
                                            payouts={payouts}
                                            accountId2accountName={
                                                accountId2accountName
                                            }
                                            setAccountIdToView={
                                                setAccountIdToView
                                            }
                                            accountId2Investors={
                                                accountId2Investors
                                            }
                                            transactionId2Status={
                                                transactionId2Status
                                            }
                                            timezoneOffset={timezoneOffset}
                                            handleStatusChange={
                                                handleStatusChange
                                            }
                                            totalInterestAmount={
                                                totalInterestAmount
                                            }
                                            accountId2Currency={
                                                accountId2Currency
                                            }
                                        />
                                    );
                                })}
                        </div>
                    </div>
                    <Summary
                        totalInterestAmount={totalInterestAmount}
                        SummaryScrollRef={SummaryScrollRef}
                        panelBackgroundColor={panelBackgroundColor}
                    />
                </div>
            )}
        </>
    );
}
